import { styled } from "styled-components";

export const NumberTransferSectionWrapper = styled.div<{
  $altStyling?: boolean;
  $hasHeading?: boolean;
}>`
  width: 100%;
  height: 100%;
  background: ${({ theme, $altStyling, $hasHeading }) =>
    $altStyling
      ? `linear-gradient(to bottom, ${theme.colors.primary[950]} ${$hasHeading ? "300px" : "200px"}, ${theme.colors.base} 0)`
      : theme.colors.base};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NumberTransferSectionContainer = styled.div`
  z-index: 1;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 0 24px 48px 24px;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  overflow-x: hidden;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: -1px;

  @media (min-width: 2400px) {
    display: none;
  }
`;

export const Disclaimer = styled.div`
  color: ${({ theme }) => theme.colors.default[600]};
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  gap: 12px;

  & > a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const NumberTransferHeader = styled.div<{ $altStyling?: boolean }>`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${({ theme, $altStyling }) =>
    $altStyling ? theme.colors.base : "inherit"};
  width: 100%;
  gap: 12px;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  padding: 48px 24px;
`;
